import { createFileRoute } from "@tanstack/react-router";
import UKMotValid from "@/pages/landing/UKMotValid";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/uk/mot-valid-cars/")({
  head: () => routeHead("/uk/mot-valid-cars/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <UKMotValid />
  );
}
